import React, { useContext, useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";


import { DataGrid, Icon } from "../../../components";
import { LoginContext } from "../../../context/login-context";

dayjs.extend(utc);

const RebatesBlock = ({ rebates, onAddRebate }) => {
  const { state: userData } = useContext(LoginContext);

  const columns = [
    {
      field: "rebate_amt",
      headerName: "Rebate Level",
      renderCell: (params) => {
        const getRebateLevel = params?.row?.rebate_amt
          ? `${params?.row?.rebate_amt*100}%`
          : "--";

        return <div>{getRebateLevel}</div>;
      },
    },
    {
      field: "created_at",
      headerName: "Created Date",
      renderCell: (params) => {
        const getDate = params?.row?.created_at
          ? dayjs.utc(params?.row?.created_at).format("MM/DD/YYYY")
          : "--";
        
        return <div>{getDate}</div>;
      }
    },
    {
      field: "deleted_at",
      headerName: "End Date",
      renderCell: (params) => {
        const getDate = params?.row?.deleted_at
          ? dayjs.utc(params?.row?.deleted_at).format("MM/DD/YYYY")
          : "Current";
        
        return <div>{getDate}</div>;
      }
    },
    {
      field: "action",
      headerName: "",
      sortable: false,
      align: "right",
      renderCell: (params) => {
        return (
          <>
          </>
        );
      },
    },
  ];

  return (
   <DataGrid
   initialState={{
    sorting: {
      sortModel: [{ field: 'deleted_at', sort: 'asc' }],
    },
  }}
    toolbarTitle="Rebate %"
    toolbarBtnTitle="+ Change rebate"
    toolbarBtnVisible= {userData?.isValmontUser}
    toolbarOnClick={onAddRebate}
    rows={rebates}
    onRowClick={(params) => {
     
    }}
    columns={columns}
      sx={{
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
      }}
  />
  );
};

export default RebatesBlock;
